import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArcadeCabinet from '../components/ArcadeCabinet';
import LandingTestimonials from '../components/LandingTestimonials';
import { getAuthStatus, getPublicStats } from '../utils/api';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [completedTasks, setCompletedTasks] = useState(null);

  useEffect(() => {
    let alive = true;
    getAuthStatus().then((res) => {
      if (alive && res.authenticated) navigate('/user-home', { replace: true });
    }).catch(() => {});
    return () => { alive = false; };
  }, [navigate]);

  useEffect(() => {
    let alive = true;
    getPublicStats().then((stats) => {
      if (alive && Number.isSafeInteger(stats?.completed_tasks) && stats.completed_tasks >= 0) {
        setCompletedTasks(stats.completed_tasks);
      }
    }).catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <Container className="arcade-landing" maxWidth={false} disableGutters sx={{
      '--cabinet-blue': theme.palette.primary.main,
      '--cabinet-pink': theme.palette.secondary.main,
      '--cabinet-green': theme.palette.green.main,
      '--cabinet-bg': theme.palette.background.default,
      '--cabinet-font': theme.typography.fontFamily,
      '--cabinet-demo-body': theme.typography.body2.fontSize,
    }}>
      <Box component="main" className="arcade-landing__main">
        <Box className="arcade-landing__machine">
          <ArcadeCabinet onStart={(destination) => navigate(destination)} />
        </Box>
        <Box className="arcade-landing__community">
          {completedTasks !== null && (
            <Box component="section" className="arcade-landing__stats" aria-label="Dopatize community progress">
              <Typography component="p" variant="h4" color="green.main">
                {completedTasks.toLocaleString()}
              </Typography>
              <Typography component="p" variant="body2" color="secondary.main">
                Tasks completed In Dopatize
              </Typography>
            </Box>
          )}
          <LandingTestimonials />
        </Box>
        <Stack className="arcade-landing__copy" spacing={2.5}>
          <Typography component="h2" variant="h5" sx={{ lineHeight: 1.7 }}>
            Collect Dopamine Not Guilt
          </Typography>
          <Typography variant="body2" sx={{ color: 'secondary.main', lineHeight: 2, maxWidth: 650 }}>
            Break down tasks, focus on the one step, and earn rewards as you go.
          </Typography>
          <Typography id="arcade-trial-note" variant="body2" sx={{ lineHeight: 2 }}>
            14 days free. No credit card needed.
          </Typography>
          <Button component={Link} to="/sign-in" variant="outlined" sx={{ borderColor: 'primary.main', px: 3, py: 1.5 }}>
            Already have an account? Sign in
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default LandingPage;
